/* @flow @format */

import { of, pipe } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

import type { ActionCreator, ActionType } from '../utils';
import type { FailurePayload } from '../types';

export function getData<D, T: { data: D }>(): rxjs$OperatorFunction<T, $NonMaybeType<D>> {
  return pipe(
    map(({ data }) => data),
    filter(Boolean)
  );
}

export function catchWith<T, AC: ActionCreator<any, FailurePayload<any>>>(
  actionCreator: AC,
  originalPayload: $PropertyType<$PropertyType<ActionType<AC>, 'payload'>, 'originalPayload'>
): rxjs$OperatorFunction<T, T | ActionType<AC>> {
  return catchError(error => of(actionCreator({ originalPayload, error })));
}
